module.exports = __webpack_public_path__ + "img/State=4.86340933.svg";